<template>
  <v-container fluid class="">

    <!-- toolbar container, to prevent parent flexer shrinking children like hlines -->

    <div>
        <!-- PC TOOLBAR -->
        <div v-if="!$vuetify.breakpoint.xs">
          
          <c-breadcrumbs :breadcrumbs="[{name: 'Invoices', to: '/invoices/'}, {name: id, disabled: true}]"></c-breadcrumbs>
          
        </div>

        <!-- MOBILE toolbar -->
        <div v-if="$vuetify.breakpoint.xs" class="toolbar-mobile">
          <v-layout align-center>
            <v-btn icon @click="drawer = !drawer">
              <v-icon>menu</v-icon>
            </v-btn>
            <v-flex class="text-ellipsed text-sans font-weight-bold">
              Sales invoice
            </v-flex>
          </v-layout>
        </div>
    </div>
    <!-- end toolbar container, to prevent parent flexer shrinking children linke hlines -->

    <!-- MAIN CONTENT -->
    <div style="overflow: auto; flex: 1;padding-bottom: 40px;">

      <div>
        <v-layout align-center class="pr-4">
          <v-spacer></v-spacer>

          <t-item-diff v-if="$store.state.settings.debugMode" :item1="lastSave" :item2="merged">
            <v-layout 
            slot="item1Header"
            align-center class="subheading font-weight-bold pl-2 crx-toolbar">
              Last save
            </v-layout>
            <v-layout 
            slot="item2Header"
            align-center class="subheading font-weight-bold pl-2 crx-toolbar">
              LIVE
            </v-layout>
          </t-item-diff>

          <v-btn
          small
          rounded
          outlined
          :to="{ path: `/print/sales-invoice/${id}` }"
          target="_blank"
          class="ml-2"
          >
            <v-icon>mdi-file-pdf-box</v-icon> Print
          </v-btn>

          <v-slide-x-transition
          mode="out-in">
            <v-btn
            v-if="isDirty"
            text
            outlined
            key="save2"
            width="8em"
            :loading="saving"

            @click="save">
              <v-icon color="color1">mdi-cloud-upload-outline</v-icon>
              <div class="ml-1">
                Save
              </div>
            </v-btn>
  
            <v-btn
            v-else
            key="save1"
            text
            width="8em"
            class="font-weight-regular"
            disabled>
              <v-icon small>mdi-shield-check-outline</v-icon>
              Saved
            </v-btn>
            
            
          </v-slide-x-transition>
          <v-btn
          v-if="$accessControl.userHasAccess(0, $store.state.auth.accessControl)"
          text
          outlined
          color="color1"
          :loading="completing">
            Complete
          </v-btn>
        </v-layout>

      </div>

      <!-- PAGE -->
      <v-card class="ma-4">
        
        <v-row class="pa-4">
          <div class="headline">
            {{ formData.type === 0 ? 'Invoice' : 'Refund' }} : <span class="">{{ formData.id_visual }}</span>
          </div>

          <v-spacer></v-spacer>

          <div>
            <div>
              Total: 
              <c-price 
              :quantity.sync="formData.total_in_base" 
              :currency="defaultCurrency.id"
              labelMode
              :class="[formData.type === 0 ? 'green--text' : 'red--text' ]">
              </c-price>
            </div>

            <v-btn small depressed @click="formData.type = 1 - formData.type">
              <v-icon small>mdi-swap-vertical-bold</v-icon>
              <span class="caption">
                Convert to {{ formData.type === 0 ? 'refund' : 'invoice'}}
              </span>
            </v-btn>
          </div>
          
        </v-row>

        <v-row class="mt-4">

          <v-col sm="6">
            <v-card outlined class="">

                <div class="title pa-4">
                  Info
                </div>

                <div class="c-hr"></div>

                <div class="pa-4">

                  <v-row class="align-start" no-gutters>
                    <v-col md="3">
                      <div class="label">ID:</div>
                    </v-col>
                    <v-col md="9">
                      <c-input :value.sync="formData.id_visual" class="crx-box-input"></c-input>
                      <div class="label caption">
                        * You should not have to change this
                      </div>
                    </v-col>
                  </v-row>

                  <v-layout align-center wrap class="mt-3">
                    <v-flex xs12 md3>
                      <div class="label">Customer</div>
                    </v-flex>
                    <v-flex xs12 md9>
                      <c-select-customer :selectedID.sync="formData.customerID" @change="changeDetected" class="crx-box-input font-weight-bold"></c-select-customer>
                    </v-flex>
                  </v-layout>

                  <v-layout align-center wrap class="mt-3">
                    <v-flex xs12 md3>
                      <div class="label">Currency</div>
                    </v-flex>
                    <v-flex xs12 md9>
                      <c-select-currency :selectedID.sync="formData.currency" class="crx-box-input"></c-select-currency>
                    </v-flex>
                  </v-layout>

                  <v-layout align-center wrap class="mt-3">
                    <v-flex xs12 md3>
                      <div class="label">Price List</div>
                    </v-flex>
                    <v-flex xs12 md9>
                      <c-select-price-list :selected.sync="formData.priceListID" class="crx-box-input"></c-select-price-list>
                    </v-flex>
                  </v-layout>

                  <v-row no-gutters class="mt-3 align-center">
                    <v-col md="3">
                      <div class="label">Date</div>
                    </v-col>
                    <v-col md="9">
                      <c-datetime :date.sync="formData.date" class="crx-box-input"></c-datetime>
                    </v-col>
                  </v-row>

                </div>
            
            </v-card>
          </v-col>

          <v-col sm="6">
            <v-card outlined>
              <div class="title pa-4">
                Address
              </div>
              <div class="c-hr"></div>

              <div class="pa-4">

                <v-layout align-start wrap class="mt-3">
                  <v-flex xs12 md3>
                    <div class="label">Bill to:</div>
                  </v-flex>
                  <v-flex xs12 md9>
                    <c-textarea :value.sync="formData.invoice_addr"></c-textarea>
                  </v-flex>
                </v-layout>

                <v-layout align-start wrap class="mt-3">
                  <v-flex xs12 md3>
                    <div class="label">Ship to:</div>
                  </v-flex>
                  <v-flex xs12 md9>
                    <template v-if="!shipToAnotherAddress">
                      <span>(the same as billing address)</span>
                      <v-spacer></v-spacer>
                      <v-btn outlined @click="shipToAnotherAddress = true">
                        EDIT
                      </v-btn>
                    </template>
                    <template v-else>
                      <c-textarea :value.sync="formData.delivery_addr"></c-textarea>
                      <v-layout justify-end>
                        <v-btn outlined @click="deleteShippingAddress">DELETE</v-btn>
                      </v-layout>
                    </template>
                  </v-flex>
                </v-layout>

              </div>

            </v-card>
          </v-col>

        </v-row>
        
        <v-row>
          <v-col sm="12">

            <v-card outlined class="mt-2">

              <v-row class="align-center pl-4 pa-2">

                <transition
                name="slide-x-reverse-transition"
                mode="out-in">

                  <!-- ITEMS -->
                  <div 
                  v-if="selectedCount === 0"
                  key="1"
                  class="c-flex-r align-center subheading">

                    <!-- select menu -->
                    <v-menu offset-y>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          icon
                          v-on="on"
                        >
                          <v-icon>mdi-check-box-multiple-outline</v-icon>
                        </v-btn>
                      </template>
                      <v-list>
                        <v-list-item
                        @click="selectAll">
                          <v-list-item-title>Select all</v-list-item-title>
                        </v-list-item>
                        <v-list-item
                        @click="selectPage">
                          <v-list-item-title>Select page</v-list-item-title>
                        </v-list-item>
                        <v-list-item
                        @click="selectNone">
                          <v-list-item-title>Select none</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>

                    <v-btn
                    depressed
                    class="mr-2 foreground--text"
                    color="text"
                    @click="selectOutput">
                      <div class="ml-1">
                        Add item
                      </div>
                    </v-btn>

                    <v-btn
                    outlined
                    class="mr-2"
                    
                    @click="addCustomItem">
                      <div class="ml-1">
                        Add custom item
                      </div>
                    </v-btn>

                  </div>

                  <!-- selected count -->
                  <div v-if="selectedCount > 0"
                  key="2"
                  class="c-flex-r align-center subheading">
                    <v-btn
                    icon
                    class=""
                    @click="selected = {}">
                      <v-icon color="color1">close</v-icon>
                    </v-btn>
                    <div class="text-sans font-weight-bold">
                      <span>&nbsp;{{ selectedCount }}</span>
                      selected 
                    </div>
                    <v-spacer v-if="$vuetify.breakpoint.xs"></v-spacer>
                    <span class="icon--text ml-2">|</span>
                    <v-btn 
                    icon
                    @click="onDelete">
                      <v-icon>delete_outline</v-icon>
                    </v-btn>
                    <!-- select menu -->
                    <v-menu offset-y>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          icon
                          v-on="on"
                        >
                          <v-icon>mdi-check-box-multiple-outline</v-icon>
                        </v-btn>
                      </template>
                      <v-list>
                        <v-list-item
                        @click="selectAll">
                          <v-list-item-title>Select all</v-list-item-title>
                        </v-list-item>
                        <v-list-item
                        @click="selectPage">
                          <v-list-item-title>Select page</v-list-item-title>
                        </v-list-item>
                        <v-list-item
                        @click="selectNone">
                          <v-list-item-title>Select none</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </div>

                </transition>

                <v-spacer></v-spacer>

                <v-tooltip bottom v-if="$accessControl.userHasAccess(0, $store.state.auth.accessControl)">
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" @click="openSettingsDialog">
                      <v-icon>
                        mdi-settings
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>Settings</span>
                </v-tooltip>

              </v-row>

              <!-- TABLE OVERFLOW -->
              <div style="overflow: auto; flex: 1; position: relative;">
                  
                <table :class="['final-table th-no-padding lines-b lines-r full-width', {'hover pointer': selectedCount !== 0}]">
                  <colgroup ref="colgroup1">
                      <col v-for="item in columnSchema" :key="item.name" :width="item.name === 'Item' ? '450px' : '150px'">
                  </colgroup>

                  <tr>

                    <template v-for="(item, i) in columnSchema">
                      <!-- item.code || item.name = item.code for default rows, item.name for json rows -->
                      <c-table-header
                      :key="item.name"
                      :title="item.name"
                      :code="item.code || item.name"
                      :class="[{'sticky' : i === 0}]"
                      :filters="filters"
                      showHandle
                      @startColDrag="startColDrag(i, $event)"
                      @onClick="clickSortHeader">
                      </c-table-header>
                    </template>

                    <!--
                    <c-table-header
                    title="Item"
                    code="item"
                    class="sticky"
                    :filters="filters"
                    showHandle
                    @startColDrag="startColDrag(0, $event)"
                    @onClick="clickSortHeader">
                    </c-table-header>
                    <c-table-header
                    title="Quantity"
                    code="quantity"
                    :filters="filters"
                    showHandle
                    @startColDrag="startColDrag(1, $event)"
                    @onClick="clickSortHeader">
                    </c-table-header>
                    <c-table-header
                    title="Weight"
                    code="weight"
                    :filters="filters"
                    showHandle
                    @startColDrag="startColDrag(2, $event)"
                    @onClick="clickSortHeader">
                    </c-table-header>
                    <c-table-header
                    title="Unit price"
                    code="unit_price"
                    :filters="filters"
                    showHandle
                    @startColDrag="startColDrag(3, $event)"
                    @onClick="clickSortHeader">
                    </c-table-header>
                    <c-table-header
                    title="Total"
                    code="total"
                    :filters="filters"
                    showHandle
                    @startColDrag="startColDrag(4, $event)"
                    @onClick="clickSortHeader">
                    </c-table-header>
                    <c-table-header
                    title="Discount (%)"
                    code="discount"
                    :filters="filters"
                    showHandle
                    @startColDrag="startColDrag(5, $event)"
                    @onClick="clickSortHeader">
                    </c-table-header>
                    <c-table-header
                    title="Total"
                    code="final_total"
                    :filters="filters"
                    showHandle
                    @startColDrag="startColDrag(6, $event)"
                    @onClick="clickSortHeader">
                    </c-table-header>
                    -->
                  </tr>

                  <tr>
                    <template v-for="(item, i) in columnSchema">
                      <td v-if="item.name === 'Item'" :class="i === 0 ? 'sticky' : ''" :key="item.name">
                        <v-text-field
                        v-model="searchText"
                        placeholder="Search"
                        hide-details
                        clearable
                        class="crx-box-input"
                        solo></v-text-field>
                      </td>
                      <td v-else :key="item.name" :class="i === 0 ? 'sticky' : ''"></td>
                    </template>
                  </tr>

                  <draggable 
                  :list="paginatedArray"
                  :element="'tbody'"
                  :options="{animation: 150, handle: '.drag-handle'}"
                  @change="dragChange">
                    <list-row
                    v-for="item in paginatedArray" 
                    :key="item.tempID"
                    :columnSchema="columnSchema"
                    vmode="table"
                    :currency="formData.currency"
                    :priceList="priceList"
                    :item="item"
                    :selected="selected"
                    :sortIndex="sortIndex"
                    :searchText="searchText"
                    @checkRow="checkRow(item)"
                    @click.native="clickRow(item)"
                    ></list-row>
                  </draggable>

                </table>

              </div>

              <!-- PAGINATION -->
              <c-pagination-client
              :page="page"
              :paginationLength="paginationLength"
              :paginatedArray="paginatedArray"
              :rowsPerPage.sync="rowsPerPage"
              @updatePageNumber="updatePageNumber"
              @goToFirstPage="goToFirstPage"
              @goToPreviousPage="goToPreviousPage"
              @goToNextPage="goToNextPage"
              @goToLastPage="goToLastPage">
              </c-pagination-client>
              <!-- PAGINATION -->
              
            </v-card>

            <v-row>
              <v-col md="6">
                <v-card outlined class="text-center pa-8">
                  <div class="">
                    Total weight
                  </div>
                  <div>
                    <c-ms-ii
                    class="display-1"
                    sid="si-mass-g"
                    :realValue="totalWeight"
                    labelMode
                    ></c-ms-ii>
                  </div>
                </v-card>
              </v-col>
              <v-col md="6">
                <v-card outlined>
                  
                  <table class="final-table full-width text-end">
                    <colgroup>
                      <col width="200px">
                      <col width="200px">
                    </colgroup>

                    <tr>
                      <td>Subtotal</td>
                      <td>
                        <c-price :quantity="netTotalCostSumFixed" labelMode :currency="formData.currency">
                        </c-price>
                      </td>
                    </tr>

                    <tr>
                      <td>Discount</td>
                      <td>
                        <c-price :quantity="netDiscount" labelMode :currency="formData.currency">
                        </c-price>
                      </td>
                    </tr>

                    <tr>
                      <td>VAT (%)</td>
                      <td>
                        <c-input :value.sync="formData.tax" class="crx-box-input"></c-input>
                      </td>
                    </tr>

                    <tr>
                      <td>Tax</td>
                      <td>
                        <c-price :quantity="totalVAT" labelMode :currency="formData.currency">
                        </c-price>
                      </td>
                    </tr>

                    <tr>
                      <td>Paid</td>
                      <td>
                        <c-price 
                        :quantity.sync="formData.paid" 
                        :currency="formData.currency"
                        class="crx-box-input">
                        </c-price>
                      </td>
                    </tr>

                    <tr class="headline">
                      <td>
                        <v-btn depressed @click="formData.type = 1 - formData.type">
                          <v-icon>mdi-swap-vertical-bold</v-icon>
                          {{ formData.type === 0 ? 'Refund' : 'Debit' }}
                        </v-btn>
                        Total
                      </td>
                      <td>
                        <c-price :quantity="amountDue" labelMode :currency="formData.currency" :class="[formData.type === 0 ? 'green--text' : 'red--text' ]">
                        </c-price>
                      </td>
                    </tr>

                  </table>
                </v-card>

                <v-card outlined class="mt-2 pa-4">
                  <v-row class="align-center">
                    <v-col sm="6">
                      <div class="caption">
                        Rate:
                      </div>
                      <div class="caption">
                        {{ primaryCurrency.symbol }} / {{ defaultCurrency.symbol }}
                      </div>
                      <div class="caption">
                        {{ base_ratio }}
                      </div>
                    </v-col>
                    <v-col sm="6" class="headline text-end">
                      <c-price 
                      :quantity.sync="formData.total_in_base" 
                      :currency="defaultCurrency.id"
                      labelMode
                      :class="[formData.type === 0 ? 'green--text' : 'red--text' ]">
                      </c-price>
                    </v-col>
                  </v-row>

                  <!-- EXPANSION -->
                  <c-expansion-panel vshow>
                    <template v-slot:header="{ expand }">
                      <div>
                        <v-row class="unselectable align-center">
                          <v-icon small color="textSecondary">mdi-tune</v-icon>
                          &nbsp;
                          <div class="caption font-weight-medium textSecondary--text">
                            SETTINGS
                          </div>
                        </v-row>
                      </div>
                    </template>
                    <template v-slot:body>
                      <div class="pa-3">
                        <div v-show="conversionNecessary">
                          <!-- Needs to be in a v-show so the automatic currency rate works -->
                          <div class="overline">
                            Rate:
                          </div>
                          <c-input :value.sync="base_ratio" class="crx-box-input"></c-input>
                          
                        </div>
                        <automatic-currency-rate :currency="formData.currency" @updateRate="updateRate" @updateRateAutomatic="updateRateAutomatic" class="mt-2"></automatic-currency-rate>
                      </div>
                    </template>
                  </c-expansion-panel>
                  <!-- EXPANSION -->
                </v-card>
                
              </v-col>
            </v-row>

          </v-col>
        </v-row>

      </v-card>
      <!-- PAGE -->

    </div>
    <!-- END MAIN CONTENT -->

    <!-- DIALOGS -->
    <c-select-inv-def-dialog ref="selectItemDialog" :exceptions="exceptionIdArray">
    </c-select-inv-def-dialog>

    <select-address-dialog ref="selectAddressDialog"></select-address-dialog>

    <settings-dialog ref="settingsDialog"></settings-dialog>

  </v-container>
</template>

<script>
import _ from 'lodash'
import axios from 'axios'
import {BigNumber} from 'bignumber.js'
import ListRow from './components/list-row'
import ListController from '@/mixins/ListController'
import SelectAddressDialog from '@/components/dialogs/select-address/dialog'
import Draggable from 'vuedraggable'
import AutomaticCurrencyRate from '@/components/select/AutomaticCurrencyRate'
import DragTableHeaders from '@/mixins/DragTableHeaders'
import SettingsDialog from '@/components/dialogs/table-columns-edit-schema/Dialog'
import { SETTINGS as STATIC_SETTINGS } from '@/js/shared/static-strings.js'

export default {
  components: {
    ListRow,
    SelectAddressDialog,
    Draggable,
    AutomaticCurrencyRate,
    SettingsDialog
  },
  mixins: [ListController, DragTableHeaders],
  props: ['id'],
  data () {
    return {
      saving: false,
      completing: false,
      priceList: [],
      shipToAnotherAddress: false,
      base_ratio: null, // if necessary provide the invoiced day conversion rate to base currency
      enableLiveConversionToBaseCurrency: false,
      formData: {
        id_visual: null,
        currency: undefined,
        customerID: null,
        priceListID: null,
        date: null,
        stage: 0,
        type: 0,
        invoice_addr: '',
        delivery_addr: '',
        tax: 0,
        paid: 0,
        total: 0,
        total_in_base: 0
      },
      lastSave: {
        id_visual: null,
        currency: undefined,
        customerID: null,
        priceListID: null,
        date: null,
        stage: 0,
        type: 0,
        invoice_addr: '',
        delivery_addr: '',
        tax: 0,
        paid: 0,
        total: 0,
        total_in_base: 0,
        rows: '[]'
      }
    }
  },
  watch: {
    'formData.priceListID': {
      immediate: true,
      handler (nv) {
        this.loadPriceList(nv)
      }
    },
    automaticBaseAmountDue (nv) {
      if (this.enableLiveConversionToBaseCurrency) {
        this.formData.total_in_base = nv
      }
    },
    amountDue (nv) {
      this.formData.total = nv
    }
  },
  computed: {
    columnSchema () {
      let schema = JSON.parse(this.$store.state.settings.dict[STATIC_SETTINGS.INVOICE_COLUMN_SCHEMA])
      return schema
    },
    defaultCurrency () {
      return this.$store.state.db.currencies.items[this.$store.state.settings.currency]
    },
    primaryCurrency () {
      return this.$store.state.db.currencies.items[this.formData.currency] || {}
    },
    conversionNecessary () {
      if (this.formData.currency !== this.defaultCurrency.id) {
        return true
      }
      return false
    },
    totalWeight () {
      return this.items.reduce((a, i) => a + i.weight, 0)
    },
    exceptionIdArray () {
      return []
    },
    isDirty () {
      return !_.isEqual(this.lastSave, this.merged)
    },
    merged () {
      var merged = {
        id_visual: this.formData.id_visual,
        customerID: this.formData.customerID,
        currency: this.formData.currency,
        priceListID: this.formData.priceListID,
        date: this.formData.date,
        stage: this.formData.stage,
        type: this.formData.type,
        invoice_addr: this.formData.invoice_addr,
        delivery_addr: this.formData.delivery_addr,
        tax: this.formData.tax,
        paid: this.formData.paid,
        total_in_base: this.formData.total_in_base,
        total: this.amountDue,
        rows: JSON.parse(JSON.stringify(this.items)),
      }
      return merged
    },
    netTotalCostSum () {
      return this.items.reduce((a, i) => {
        return a + Number(i.total_cost)
      }, 0)
    },
    netTotalCostSumFixed() {     
      return Number(this.netTotalCostSum).toFixed(2)
    },
    netDiscount () {
      return this.items.reduce((a, i) => {
        var discount = new BigNumber(i.discount || 0).dividedBy(100)
        return a + (i.total_cost * discount)
      }, 0)
    },
    subtotalMinusDiscount () {
      return this.netTotalCostSum - this.netDiscount
    },
    totalVAT () {
      var percent = Number(this.formData.tax) / 100
      return this.subtotalMinusDiscount * percent
    },
    amountDue () {
      var due = this.subtotalMinusDiscount + this.totalVAT - this.formData.paid
      if (this.formData.type === 1) {
        return -Math.abs(due)
      } else {
        return Math.abs(due)
      }
    },
    automaticBaseAmountDue () {
      var due = this.amountDue * this.base_ratio
      if (this.formData.type === 1) {
        return -Math.abs(due)
      } else {
        return Math.abs(due)
      }
    },
  },
  methods: {
    openSettingsDialog () {
      this.$refs.settingsDialog.open('invoice_column_schema')
    },
    updateRate (rate) {
      this.base_ratio = rate.rate
      this.$nextTick(() => {
        // force an update
        this.formData.total_in_base = this.automaticBaseAmountDue
      })
    },
    updateRateAutomatic (rate) {
      if (!this.base_ratio) {
        this.base_ratio = rate.rate
      }
      if (this.formData.currency !== this.lastSave.currency) {
        this.base_ratio = rate.rate
      }

      if (this.defaultCurrency.id === this.formData.currency) {
        this.base_ratio = 1
      }
    },
    sort (items) {
      return items.sort((a, b) => a.ordering - b.ordering)
    },
    deleteShippingAddress () {
      this.formData.delivery_addr = ''
      this.shipToAnotherAddress = false
    },
    changeDetected (customer) {
      if (customer) {
        this.formData.invoice_addr = customer.document_block
      }
    },
    addressToString (address) {
      var str = ''
      if (address) {
        var lines = [address.address, address.address2, address.state, address.city, address.zip_code, address.country]
        for (var line of lines) {
          if (line) {
            str += line + '\n'
          }
        }
      }
      return str
    },
    search (items) {
      if ((this.searchText || '').length > 0) {
        var keywords = (this.searchText || '').toLowerCase().split(' ')
        items = items.filter(item => {
          return keywords.every(keyword => {
            if (item.json_data) { // if custom item
              var json_data = Object.assign({}, {name: ''}, item.json_data)
              return (json_data.name.toLowerCase()).indexOf(keyword) > -1
            } else { // if normal item
              return (item.definition.name.toLowerCase()).indexOf(keyword) > -1
            }
          })
        })
      }
      return items
    },
    selectOutput () {
      this.$refs.selectItemDialog.open()
        .then((selectedItem) => {
          this.items.push({
            definition: selectedItem,
            inventory_item_id: selectedItem.id,
            quantity: 0,
            weight: 0,
            cost_per_unit: 0,
            discount: 0,
            total_cost: 0,
            custom_columns: {}
          })
        })
        .catch(() => {
          // console.log('rejected')
        })
    },
    addCustomItem () {
      this.items.push({
        json_data: {},
        custom_columns: {},
        quantity: 0,
        weight: 0,
        cost_per_unit: 0,
        discount: 0,
        total_cost: 0
      })
    },
    clickRow (item) {
      if (this.selectedCount > 0) {
        this.checkRow(item)
      } else {
        // this.$router.push('/sale/' + item.id)
      }
    },
    save () {
      this.saveAxios()
      .then(() => {
        this.reload()
      })
      .catch(error => this.$root.$errorSnackbar(error))
    },
    saveAxios () {
      return new Promise((resolve, reject) => {
        var prunedRows = this.items.map(item => {
          return {
            id: item.id,
            name: item.name,
            inventory_item_id: item.inventory_item_id,
            weight: item.weight,
            quantity: item.quantity,
            cost_per_unit: item.cost_per_unit,
            discount: item.discount,
            total_cost: item.total_cost,
            tempID: item.tempID,
            ordering: item.ordering,
            json_data: item.json_data,
            custom_columns: item.custom_columns,
          }
        })
        let data = {
          id_visual: this.formData.id_visual || null,
          customerID: this.formData.customerID,
          currency: this.formData.currency,
          invoice_addr: this.formData.invoice_addr,
          delivery_addr: this.formData.delivery_addr,
          type: this.formData.type,
          tax: this.formData.tax || 0,
          paid: this.formData.paid || 0,
          total: this.amountDue,
          total_in_base: this.formData.total_in_base,
          priceListID: this.formData.priceListID,
          date: this.formData.date,
          rows: JSON.parse(JSON.stringify(prunedRows))
        }
        console.log(data)
        this.saving = true
        this.$axios.patch('sales-invoices/sales-invoice/' + this.id,
          data,
          {headers: {'Content-Type': 'application/json'}})
          .then(response => {
            resolve()
          })
          .catch(error => {
            console.log(error)
            this.$root.$errorSnackbar(error)
            reject(error)
          })
          .then(() => {
            setTimeout(() => {
            this.saving = false
            }, 200)
          })
      })
    },
    onDelete () {
      var selectedRows = this.getSelectedRows()
      var idArray = selectedRows.reduce((a, i) => {
        a.push(i.tempID)
        return a
      }, [])
      var title = 'Delete ' + idArray.length + ' row' + (idArray.length === 1 ? '' : 's') + '?'
      this.$root.$confirm(title, 'Are you sure?', { color: 'purple' }).then((confirm) => {
        if (confirm) {
          for (var i = this.items.length - 1; i >= 0; --i) {
            if (idArray.includes(this.items[i].tempID)) {
              this.items.splice(i, 1)
            }
          }
          this.onSuccessfullDelete()
        }
      })
    },
    reload () {
      axios.all([
        this.$axios.get('/sales-invoices/' + this.id),
      ])
      .then(axios.spread((response) => {
        console.log(response)
        var invoice = response.data.invoice

        this.formData.id_visual = invoice.id_visual
        this.formData.customerID = invoice.customer
        this.formData.currency = invoice.currency || this.$store.state.settings.currency
        this.formData.priceListID = invoice.price_list
        this.formData.date = invoice.date || this.$moment()
        this.formData.invoice_addr = invoice.invoice_addr || ''
        this.formData.delivery_addr = invoice.delivery_addr || ''
        this.formData.type = invoice.type,
        this.formData.tax = invoice.tax
        this.formData.paid = invoice.paid
        this.formData.total_in_base = invoice.total_in_base || 0
        this.items = response.data.rows
        this.items.map(item => {
          item.json_data = JSON.parse(item.json_data)
          item.custom_columns = JSON.parse(item.custom_columns) || {}
        })

        this.resort()
        this.$nextTick(() => {
          this.lastSave.id_visual = invoice.id_visual
          this.lastSave.customerID = invoice.customer
          this.lastSave.currency = invoice.currency
          this.lastSave.priceListID = invoice.price_list
          this.lastSave.date = invoice.date
          this.lastSave.invoice_addr = invoice.invoice_addr || ''
          this.lastSave.delivery_addr = invoice.delivery_addr || ''
          this.lastSave.type = invoice.type,
          this.lastSave.tax = invoice.tax
          this.lastSave.paid = invoice.paid
          this.lastSave.total = this.amountDue
          this.lastSave.total_in_base = invoice.total_in_base || 0
          this.lastSave.rows = JSON.parse(JSON.stringify(this.items))
          if (invoice.total_in_base) {
            this.base_ratio = invoice.total_in_base / invoice.total
          }
        })
        if (invoice.delivery_addr) {
          this.shipToAnotherAddress = true
        }
      }))
      .catch(error => {
        console.log(error)
        this.$root.$errorSnackbar(error)
      })
      .then(() => this.enableLiveConversionToBaseCurrency = true)
    },
    loadPriceList (id) {
      this.$axios.get('/price-list-items/' + id)
        .then(priceListItems => {
          this.priceList = priceListItems.data
        })
        .catch(error => this.$root.$errorSnackbar(error))
    }
  },
  created () {
    this.reload()
  },
  mounted () {
    this.colGroupRefs.push(this.$refs.colgroup1)
    window.addEventListener('mousemove', this.onMouseMove)
    window.addEventListener('mouseup', this.mouseUp)
  }
}
</script>
